var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8001 6.40006C21.1314 6.84189 21.0419 7.46869 20.6001 7.80006L14.4001 12.4501L14.4 12.4501C12.9778 13.5167 11.0223 13.5167 9.60007 12.4501L9.60006 12.4501L3.40006 7.80011C2.95823 7.46874 2.86869 6.84194 3.20006 6.40011C3.53142 5.95828 4.15823 5.86874 4.60005 6.20011L10.8 10.85C10.8 10.8501 10.8001 10.8501 10.8001 10.8501C11.5112 11.3834 12.4889 11.3834 13.2001 10.8501C13.2001 10.8501 13.2001 10.8501 13.2001 10.85L19.4001 6.20006C19.8419 5.86869 20.4687 5.95823 20.8001 6.40006Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V7C20 6.44772 19.5523 6 19 6H5ZM2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.8e7f6300cac5ee7a6df50777845d4e40.svg";
export { ForwardRef as ReactComponent };